import { createReducer } from '@reduxjs/toolkit';

import { SingleInquiryFormValues } from '../pages/modals/single-inquiry/models/single-inquiry-form-values';
import { closeInquiryModal, openInquiryModal } from './single-inquiry-actions';

export interface SingleInquiryState {
    isSingleInquiryModalOpen: boolean;
    initialValues: Partial<SingleInquiryFormValues>;
}

const initialState: SingleInquiryState = {
    isSingleInquiryModalOpen: false,
    initialValues: {},
};

export const singleInquiryReducer = createReducer(initialState, builder => {
    builder.addCase(openInquiryModal, (state, action) => ({
        ...state,
        isSingleInquiryModalOpen: true,
        initialValues: action.payload ?? {},
    }));
    builder.addCase(closeInquiryModal, state => ({ ...state, isSingleInquiryModalOpen: false }));
});
